import CT from '@marketplace-ai/tags';
import { createElement } from 'react';
import { Link } from 'react-router';
import { Column } from '~/components';
import { buildJobOpportunitiesUrl } from '~/routing';
import type { JobListing } from '~/types/hlx/jobListing';
import { countOpenResponses } from '../responseCount';

const TAGS = CT.employer.jobListings.table;

// [MCV-1587] Delegates so the Responses column and the delete/deactivate
// branch can never drift apart on what counts as an open response.
export const getJobListingResponseCount = (row: Pick<JobListing, 'jobResponses'>) =>
  countOpenResponses(row);

export const TABLE_COLUMNS: Column<JobListing>[] = [
  { label: 'Listing ID', data: 'id', sortKey: 'id', cyTag: 'id' },
  {
    label: 'Title',
    data: 'jobTitle',
    cyTag: TAGS.title,
  },
  {
    label: 'Work Location',
    data: 'workLocation',
    formatter: (data) => data.charAt(0) + data.slice(1).toLowerCase(),
    cyTag: TAGS.workLocation,
  },
  {
    label: 'Active',
    data: (row) => (row.activeFlag ? 'Yes' : 'No'),
    cyTag: TAGS.activeFlag,
  },
  {
    label: 'Filled',
    data: (row) => (row.filledFlag ? 'Yes' : 'No'),
    cyTag: TAGS.filledFlag,
  },
  {
    label: 'Responses',
    data: (row) => {
      const count = getJobListingResponseCount(row);
      if (row.id == null) return String(count);

      return createElement(
        Link,
        {
          to: buildJobOpportunitiesUrl({ listingId: row.id }),
          className: 'font-semibold text-primary-t-50 hover:underline',
          'aria-label': `View ${count} provider responses for listing ${row.id}`,
        },
        count
      );
    },
    cyTag: 'responses',
  },
];
